
(function (global, undefined) {
    'use strict';

    var factory = function (window) {
        if (typeof window.document !== 'object') {
            throw new Error('Cookies.js requires a `window` with a `document` object');
        }

        var Cookies = function (key, value, options) {
            return arguments.length === 1 ?
                Cookies.get(key) : Cookies.set(key, value, options);
        };

        // Allows for setter injection in unit tests
        Cookies._document = window.document;

        // Used to ensure cookie keys do not collide with
        // built-in `Object` properties
        Cookies._cacheKeyPrefix = 'cookey.'; // Hurr hurr, :)

        Cookies._maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');

        Cookies.defaults = {
            path: '/',
            secure: false
        };

        Cookies.get = function (key) {
            if (Cookies._cachedDocumentCookie !== Cookies._document.cookie) {
                Cookies._renewCache();
            }

            var value = Cookies._cache[Cookies._cacheKeyPrefix + key];

            return value === undefined ? undefined : decodeURIComponent(value);
        };

        Cookies.set = function (key, value, options) {
            options = Cookies._getExtendedOptions(options);
            options.expires = Cookies._getExpiresDate(value === undefined ? -1 : options.expires);

            Cookies._document.cookie = Cookies._generateCookieString(key, value, options);

            return Cookies;
        };

        Cookies.expire = function (key, options) {
            return Cookies.set(key, undefined, options);
        };

        Cookies._getExtendedOptions = function (options) {
            return {
                path: options && options.path || Cookies.defaults.path,
                domain: options && options.domain || Cookies.defaults.domain,
                expires: options && options.expires || Cookies.defaults.expires,
                secure: options && options.secure !== undefined ?  options.secure : Cookies.defaults.secure
            };
        };

        Cookies._isValidDate = function (date) {
            return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
        };

        Cookies._getExpiresDate = function (expires, now) {
            now = now || new Date();

            if (typeof expires === 'number') {
                expires = expires === Infinity ?
                    Cookies._maxExpireDate : new Date(now.getTime() + expires * 1000);
            } else if (typeof expires === 'string') {
                expires = new Date(expires);
            }

            if (expires && !Cookies._isValidDate(expires)) {
                throw new Error('`expires` parameter cannot be converted to a valid Date instance');
            }

            return expires;
        };

        Cookies._generateCookieString = function (key, value, options) {
            key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
            key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
            value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
            options = options || {};

            var cookieString = key + '=' + value;
            cookieString += options.path ? ';path=' + options.path : '';
            cookieString += options.domain ? ';domain=' + options.domain : '';
            cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
            cookieString += options.secure ? ';secure' : '';
            return cookieString;
        };

        Cookies._getCacheFromString = function (documentCookie) {
            var cookieCache = {};
            var cookiesArray = documentCookie ? documentCookie.split('; ') : [];

            for (var i = 0; i < cookiesArray.length; i++) {
                var cookieKvp = Cookies._getKeyValuePairFromCookieString(cookiesArray[i]);

                if (cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] === undefined) {
                    cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] = cookieKvp.value;
                }
            }

            return cookieCache;
        };

        Cookies._getKeyValuePairFromCookieString = function (cookieString) {
            // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
            var separatorIndex = cookieString.indexOf('=');

            // IE omits the "=" when the cookie value is an empty string
            separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;

            var key = cookieString.substr(0, separatorIndex);
            var decodedKey;
            try {
                decodedKey = decodeURIComponent(key);
            } catch (e) {
                if (console && typeof console.error === 'function') {
                    console.error('Could not decode cookie with key "' + key + '"', e);
                }
            }

            return {
                key: decodedKey,
                value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
            };
        };

        Cookies._renewCache = function () {
            Cookies._cache = Cookies._getCacheFromString(Cookies._document.cookie);
            Cookies._cachedDocumentCookie = Cookies._document.cookie;
        };

        Cookies._areEnabled = function () {
            var testKey = 'cookies.js';
            var areEnabled = Cookies.set(testKey, 1).get(testKey) === '1';
            Cookies.expire(testKey);
            return areEnabled;
        };

        Cookies.enabled = Cookies._areEnabled();

        return Cookies;
    };

    var cookiesExport = typeof global.document === 'object' ? factory(global) : factory;

    // AMD support
    if (typeof define === 'function' && define.amd) {
        define(function () { return cookiesExport; });
        // CommonJS/Node.js support
    } else if (typeof exports === 'object') {
        // Support Node.js specific `module.exports` (which can be a function)
        if (typeof module === 'object' && typeof module.exports === 'object') {
            exports = module.exports = cookiesExport;
        }
        // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
        exports.Cookies = cookiesExport;
    } else {
        global.Cookies = cookiesExport;
    }
})(typeof window === 'undefined' ? this : window);









/**
 * NetteForms - simple forme validation.
 *
 * This file is part of the Nette Framework (https://nette.org)
 * Copyright (c) 2004 David Grudl (https://davidgrudl.com)
 */

(function(global, factory) {
    if (!global.JSON) {
        return;
    }

    if (typeof define === 'function' && define.amd) {
        define(function() {
            return factory(global);
        });
    } else if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = factory(global);
    } else {
        var init = !global.Nette || !global.Nette.noInit;
        global.Nette = factory(global);
        if (init) {
            global.Nette.initOnLoad();
        }
    }

}(typeof window !== 'undefined' ? window : this, function(window) {

    'use strict';

    var Nette = {};

    Nette.formErrors = [];
    Nette.version = '2.4';


    /**
     * Attaches a handler to an event for the element.
     */
    Nette.addEvent = function(element, on, callback) {
        if (element.addEventListener) {
            element.addEventListener(on, callback);
        } else if (on === 'DOMContentLoaded') {
            element.attachEvent('onreadystatechange', function() {
                if (element.readyState === 'complete') {
                    callback.call(this);
                }
            });
        } else {
            element.attachEvent('on' + on, getHandler(callback));
        }
    };


    function getHandler(callback) {
        return function(e) {
            return callback.call(this, e);
        };
    }


    /**
     * Returns the value of form element.
     */
    Nette.getValue = function(elem) {
        var i;
        if (!elem) {
            return null;

        } else if (!elem.tagName) { // RadioNodeList, HTMLCollection, array
            return elem[0] ? Nette.getValue(elem[0]) : null;

        } else if (elem.type === 'radio') {
            var elements = elem.form.elements; // prevents problem with name 'item' or 'namedItem'
            for (i = 0; i < elements.length; i++) {
                if (elements[i].name === elem.name && elements[i].checked) {
                    return elements[i].value;
                }
            }
            return null;

        } else if (elem.type === 'file') {
            return elem.files || elem.value;

        } else if (elem.tagName.toLowerCase() === 'select') {
            var index = elem.selectedIndex,
                options = elem.options,
                values = [];

            if (elem.type === 'select-one') {
                return index < 0 ? null : options[index].value;
            }

            for (i = 0; i < options.length; i++) {
                if (options[i].selected) {
                    values.push(options[i].value);
                }
            }
            return values;

        } else if (elem.name && elem.name.match(/\[\]$/)) { // multiple elements []
            var elements = elem.form.elements[elem.name].tagName ? [elem] : elem.form.elements[elem.name],
                values = [];

            for (i = 0; i < elements.length; i++) {
                if (elements[i].type !== 'checkbox' || elements[i].checked) {
                    values.push(elements[i].value);
                }
            }
            return values;

        } else if (elem.type === 'checkbox') {
            return elem.checked;

        } else if (elem.tagName.toLowerCase() === 'textarea') {
            return elem.value.replace('\r', '');

        } else {
            return elem.value.replace('\r', '').replace(/^\s+|\s+$/g, '');
        }
    };


    /**
     * Returns the effective value of form element.
     */
    Nette.getEffectiveValue = function(elem, filter) {
        var val = Nette.getValue(elem);
        if (elem.getAttribute) {
            if (val === elem.getAttribute('data-nette-empty-value')) {
                val = '';
            }
        }
        if (filter) {
            var ref = {value: val};
            Nette.validateControl(elem, null, true, ref);
            val = ref.value;
        }
        return val;
    };


    /**
     * Validates form element against given rules.
     */
    Nette.validateControl = function(elem, rules, onlyCheck, value, emptyOptional) {
        elem = elem.tagName ? elem : elem[0]; // RadioNodeList
        rules = rules || Nette.parseJSON(elem.getAttribute('data-nette-rules'));
        value = value === undefined ? {value: Nette.getEffectiveValue(elem)} : value;

        for (var id = 0, len = rules.length; id < len; id++) {
            var rule = rules[id],
                op = rule.op.match(/(~)?([^?]+)/),
                curElem = rule.control ? elem.form.elements.namedItem(rule.control) : elem;

            rule.neg = op[1];
            rule.op = op[2];
            rule.condition = !!rule.rules;

            if (!curElem) {
                continue;
            } else if (rule.op === 'optional') {
                emptyOptional = !Nette.validateRule(elem, ':filled', null, value);
                continue;
            } else if (emptyOptional && !rule.condition && rule.op !== ':filled') {
                continue;
            }

            curElem = curElem.tagName ? curElem : curElem[0]; // RadioNodeList
            var success = Nette.validateRule(curElem, rule.op, rule.arg, elem === curElem ? value : undefined);

            if (success === null) {
                continue;
            } else if (rule.neg) {
                success = !success;
            }

            if (rule.condition && success) {
                if (!Nette.validateControl(elem, rule.rules, onlyCheck, value, rule.op === ':blank' ? false : emptyOptional)) {
                    return false;
                }
            } else if (!rule.condition && !success) {
                if (Nette.isDisabled(curElem)) {
                    continue;
                }
                if (!onlyCheck) {
                    var arr = Nette.isArray(rule.arg) ? rule.arg : [rule.arg],
                        message = rule.msg.replace(/%(value|\d+)/g, function(foo, m) {
                            return Nette.getValue(m === 'value' ? curElem : elem.form.elements.namedItem(arr[m].control));
                        });
                    Nette.addError(curElem, message);
                }
                return false;
            }
        }

        if (elem.type === 'number' && !elem.validity.valid) {
            if (!onlyCheck) {
                Nette.addError(elem, 'Please enter a valid value.');
            }
            return false;
        }

        return true;
    };


    /**
     * Validates whole form.
     */
    Nette.validateForm = function(sender, onlyCheck) {
        var form = sender.form || sender,
            scope = false;

        Nette.formErrors = [];

        if (form['nette-submittedBy'] && form['nette-submittedBy'].getAttribute('formnovalidate') !== null) {
            var scopeArr = Nette.parseJSON(form['nette-submittedBy'].getAttribute('data-nette-validation-scope'));
            if (scopeArr.length) {
                scope = new RegExp('^(' + scopeArr.join('-|') + '-)');
            } else {
                Nette.showFormErrors(form, []);
                return true;
            }
        }

        var radios = {}, i, elem;

        for (i = 0; i < form.elements.length; i++) {
            elem = form.elements[i];

            if (elem.tagName && !(elem.tagName.toLowerCase() in {input: 1, select: 1, textarea: 1, button: 1})) {
                continue;

            } else if (elem.type === 'radio') {
                if (radios[elem.name]) {
                    continue;
                }
                radios[elem.name] = true;
            }

            if ((scope && !elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) || Nette.isDisabled(elem)) {
                continue;
            }

            if (!Nette.validateControl(elem, null, onlyCheck) && !Nette.formErrors.length) {
                return false;
            }
        }
        var success = !Nette.formErrors.length;
        Nette.showFormErrors(form, Nette.formErrors);
        return success;
    };


    /**
     * Check if input is disabled.
     */
    Nette.isDisabled = function(elem) {
        if (elem.type === 'radio') {
            for (var i = 0, elements = elem.form.elements; i < elements.length; i++) {
                if (elements[i].name === elem.name && !elements[i].disabled) {
                    return false;
                }
            }
            return true;
        }
        return elem.disabled;
    };


    /**
     * Adds error message to the queue.
     */
    Nette.addError = function(elem, message) {
        Nette.formErrors.push({
            element: elem,
            message: message
        });
    };


    /**
     * Display error messages.
     */
    Nette.showFormErrors = function(form, errors) {
        var messages = [],
            focusElem;

        for (var i = 0; i < errors.length; i++) {
            var elem = errors[i].element,
                message = errors[i].message;

            if (!Nette.inArray(messages, message)) {
                messages.push(message);

                if (!focusElem && elem.focus) {
                    focusElem = elem;
                }
            }
        }

        if (messages.length) {
            alert(messages.join('\n'));

            if (focusElem) {
                focusElem.focus();
            }
        }
    };


    var preventFiltering = false;

    /**
     * Validates single rule.
     */
    Nette.validateRule = function(elem, op, arg, value) {
        value = value === undefined ? {value: Nette.getEffectiveValue(elem, true)} : value;

        if (op.charAt(0) === ':') {
            op = op.substr(1);
        }
        op = op.replace('::', '_');
        op = op.replace(/\\/g, '');

        var arr = Nette.isArray(arg) ? arg.slice(0) : [arg];
        if (!preventFiltering) {
            preventFiltering = true;
            for (var i = 0, len = arr.length; i < len; i++) {
                if (arr[i] && arr[i].control) {
                    var control = elem.form.elements.namedItem(arr[i].control);
                    arr[i] = control === elem ? value.value : Nette.getEffectiveValue(control, true);
                }
            }
            preventFiltering = false;
        }
        return Nette.validators[op]
            ? Nette.validators[op](elem, Nette.isArray(arg) ? arr : arr[0], value.value, value)
            : null;
    };


    Nette.validators = {
        filled: function(elem, arg, val) {
            if (elem.type === 'number' && elem.validity.badInput) {
                return true;
            }
            return val !== '' && val !== false && val !== null
                && (!Nette.isArray(val) || !!val.length)
                && (!window.FileList || !(val instanceof window.FileList) || val.length);
        },

        blank: function(elem, arg, val) {
            return !Nette.validators.filled(elem, arg, val);
        },

        valid: function(elem) {
            return Nette.validateControl(elem, null, true);
        },

        equal: function(elem, arg, val) {
            if (arg === undefined) {
                return null;
            }

            function toString(val) {
                if (typeof val === 'number' || typeof val === 'string') {
                    return '' + val;
                } else {
                    return val === true ? '1' : '';
                }
            }

            val = Nette.isArray(val) ? val : [val];
            arg = Nette.isArray(arg) ? arg : [arg];
            loop:
                for (var i1 = 0, len1 = val.length; i1 < len1; i1++) {
                    for (var i2 = 0, len2 = arg.length; i2 < len2; i2++) {
                        if (toString(val[i1]) === toString(arg[i2])) {
                            continue loop;
                        }
                    }
                    return false;
                }
            return true;
        },

        notEqual: function(elem, arg, val) {
            return arg === undefined ? null : !Nette.validators.equal(elem, arg, val);
        },

        minLength: function(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.tooShort) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            return val.length >= arg;
        },

        maxLength: function(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.tooLong) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            return val.length <= arg;
        },

        length: function(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.tooShort || elem.validity.tooLong) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            arg = Nette.isArray(arg) ? arg : [arg, arg];
            return (arg[0] === null || val.length >= arg[0]) && (arg[1] === null || val.length <= arg[1]);
        },

        email: function(elem, arg, val) {
            return (/^("([ !#-[\]-~]|\\[ -~])+"|[-a-z0-9!#$%&'*+\/=?^_`{|}~]+(\.[-a-z0-9!#$%&'*+\/=?^_`{|}~]+)*)@([0-9a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,61}[0-9a-z\u00C0-\u02FF\u0370-\u1EFF])?\.)+[a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,17}[a-z\u00C0-\u02FF\u0370-\u1EFF])?$/i).test(val);
        },

        url: function(elem, arg, val, value) {
            if (!(/^[a-z\d+.-]+:/).test(val)) {
                val = 'http://' + val;
            }
            if ((/^https?:\/\/((([-_0-9a-z\u00C0-\u02FF\u0370-\u1EFF]+\.)*[0-9a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,61}[0-9a-z\u00C0-\u02FF\u0370-\u1EFF])?\.)?[a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,17}[a-z\u00C0-\u02FF\u0370-\u1EFF])?|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|\[[0-9a-f:]{3,39}\])(:\d{1,5})?(\/\S*)?$/i).test(val)) {
                value.value = val;
                return true;
            }
            return false;
        },

        regexp: function(elem, arg, val) {
            var parts = typeof arg === 'string' ? arg.match(/^\/(.*)\/([imu]*)$/) : false;
            try {
                return parts && (new RegExp(parts[1], parts[2].replace('u', ''))).test(val);
            } catch (e) {}
        },

        pattern: function(elem, arg, val) {
            try {
                return typeof arg === 'string' ? (new RegExp('^(?:' + arg + ')$')).test(val) : null;
            } catch (e) {}
        },

        integer: function(elem, arg, val) {
            if (elem.type === 'number' && elem.validity.badInput) {
                return false;
            }
            return (/^-?[0-9]+$/).test(val);
        },

        'float': function(elem, arg, val, value) {
            if (elem.type === 'number' && elem.validity.badInput) {
                return false;
            }
            val = val.replace(' ', '').replace(',', '.');
            if ((/^-?[0-9]*[.,]?[0-9]+$/).test(val)) {
                value.value = val;
                return true;
            }
            return false;
        },

        min: function(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.rangeUnderflow) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            return arg === null || parseFloat(val) >= arg;
        },

        max: function(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.rangeOverflow) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            return arg === null || parseFloat(val) <= arg;
        },

        range: function(elem, arg, val) {
            if (elem.type === 'number') {
                if (elem.validity.rangeUnderflow || elem.validity.rangeOverflow) {
                    return false;
                } else if (elem.validity.badInput) {
                    return null;
                }
            }
            return Nette.isArray(arg) ?
                ((arg[0] === null || parseFloat(val) >= arg[0]) && (arg[1] === null || parseFloat(val) <= arg[1])) : null;
        },

        submitted: function(elem) {
            return elem.form['nette-submittedBy'] === elem;
        },

        fileSize: function(elem, arg, val) {
            if (window.FileList) {
                for (var i = 0; i < val.length; i++) {
                    if (val[i].size > arg) {
                        return false;
                    }
                }
            }
            return true;
        },

        image: function (elem, arg, val) {
            if (window.FileList && val instanceof window.FileList) {
                for (var i = 0; i < val.length; i++) {
                    var type = val[i].type;
                    if (type && type !== 'image/gif' && type !== 'image/png' && type !== 'image/jpeg') {
                        return false;
                    }
                }
            }
            return true;
        },

        'static': function (elem, arg, val) {
            return arg;
        }
    };


    /**
     * Process all toggles in form.
     */
    Nette.toggleForm = function(form, elem) {
        var i;
        Nette.toggles = {};
        for (i = 0; i < form.elements.length; i++) {
            if (form.elements[i].tagName.toLowerCase() in {input: 1, select: 1, textarea: 1, button: 1}) {
                Nette.toggleControl(form.elements[i], null, null, !elem);
            }
        }

        for (i in Nette.toggles) {
            Nette.toggle(i, Nette.toggles[i], elem);
        }
    };


    /**
     * Process toggles on form element.
     */
    Nette.toggleControl = function(elem, rules, success, firsttime, value) {
        rules = rules || Nette.parseJSON(elem.getAttribute('data-nette-rules'));
        value = value === undefined ? {value: Nette.getEffectiveValue(elem)} : value;

        var has = false,
            handled = [],
            handler = function () {
                Nette.toggleForm(elem.form, elem);
            },
            curSuccess;

        for (var id = 0, len = rules.length; id < len; id++) {
            var rule = rules[id],
                op = rule.op.match(/(~)?([^?]+)/),
                curElem = rule.control ? elem.form.elements.namedItem(rule.control) : elem;

            if (!curElem) {
                continue;
            }

            curSuccess = success;
            if (success !== false) {
                rule.neg = op[1];
                rule.op = op[2];
                curSuccess = Nette.validateRule(curElem, rule.op, rule.arg, elem === curElem ? value : undefined);
                if (curSuccess === null) {
                    continue;

                } else if (rule.neg) {
                    curSuccess = !curSuccess;
                }
                if (!rule.rules) {
                    success = curSuccess;
                }
            }

            if ((rule.rules && Nette.toggleControl(elem, rule.rules, curSuccess, firsttime, value)) || rule.toggle) {
                has = true;
                if (firsttime) {
                    var oldIE = !document.addEventListener, // IE < 9
                        name = curElem.tagName ? curElem.name : curElem[0].name,
                        els = curElem.tagName ? curElem.form.elements : curElem;

                    for (var i = 0; i < els.length; i++) {
                        if (els[i].name === name && !Nette.inArray(handled, els[i])) {
                            Nette.addEvent(els[i], oldIE && els[i].type in {checkbox: 1, radio: 1} ? 'click' : 'change', handler);
                            handled.push(els[i]);
                        }
                    }
                }
                for (var id2 in rule.toggle || []) {
                    if (Object.prototype.hasOwnProperty.call(rule.toggle, id2)) {
                        Nette.toggles[id2] = Nette.toggles[id2] || (rule.toggle[id2] ? curSuccess : !curSuccess);
                    }
                }
            }
        }
        return has;
    };


    Nette.parseJSON = function(s) {
        return (s || '').substr(0, 3) === '{op'
            ? eval('[' + s + ']') // backward compatibility with Nette 2.0.x
            : JSON.parse(s || '[]');
    };


    /**
     * Displays or hides HTML element.
     */
    Nette.toggle = function(id, visible, srcElement) {
        var elem = document.getElementById(id);
        if (elem) {
            elem.style.display = visible ? '' : 'none';
        }
    };


    /**
     * Setup handlers.
     */
    Nette.initForm = function(form) {
        Nette.toggleForm(form);

        if (form.noValidate) {
            return;
        }

        form.noValidate = true;

        Nette.addEvent(form, 'submit', function(e) {
            if (!Nette.validateForm(form)) {
                if (e && e.stopPropagation) {
                    e.stopPropagation();
                    e.preventDefault();
                } else if (window.event) {
                    event.cancelBubble = true;
                    event.returnValue = false;
                }
            }
        });
    };


    /**
     * @private
     */
    Nette.initOnLoad = function() {
        Nette.addEvent(document, 'DOMContentLoaded', function() {
            for (var i = 0; i < document.forms.length; i++) {
                var form = document.forms[i];
                for (var j = 0; j < form.elements.length; j++) {
                    if (form.elements[j].getAttribute('data-nette-rules')) {
                        Nette.initForm(form);
                        break;
                    }
                }
            }

            Nette.addEvent(document.body, 'click', function(e) {
                var target = e.target || e.srcElement;
                while (target) {
                    if (target.form && target.type in {submit: 1, image: 1}) {
                        target.form['nette-submittedBy'] = target;
                        break;
                    }
                    target = target.parentNode;
                }
            });
        });
    };


    /**
     * Determines whether the argument is an array.
     */
    Nette.isArray = function(arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };


    /**
     * Search for a specified value within an array.
     */
    Nette.inArray = function(arr, val) {
        if ([].indexOf) {
            return arr.indexOf(val) > -1;
        } else {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] === val) {
                    return true;
                }
            }
            return false;
        }
    };


    /**
     * Converts string to web safe characters [a-z0-9-] text.
     */
    Nette.webalize = function(s) {
        s = s.toLowerCase();
        var res = '', i, ch;
        for (i = 0; i < s.length; i++) {
            ch = Nette.webalizeTable[s.charAt(i)];
            res += ch ? ch : s.charAt(i);
        }
        return res.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    };

    Nette.webalizeTable = {\u00e1: 'a', \u00e4: 'a', \u010d: 'c', \u010f: 'd', \u00e9: 'e', \u011b: 'e', \u00ed: 'i', \u013e: 'l', \u0148: 'n', \u00f3: 'o', \u00f4: 'o', \u0159: 'r', \u0161: 's', \u0165: 't', \u00fa: 'u', \u016f: 'u', \u00fd: 'y', \u017e: 'z'};

    return Nette;
}));

// nette ajax
(function(b,c,d){if(typeof c!="function"){return console.error("nette.ajax.js: jQuery is missing, load it please")}var a=function(){var e={self:this,initialized:false,contexts:{},on:{init:{},load:{},prepare:{},before:{},start:{},success:{},complete:{},error:{}},fire:function(){var f=true;var h=Array.prototype.slice.call(arguments);var i=h.shift();var g=(typeof i=="string")?i:i.name;var j=(typeof i=="object")?i.off||{}:{};h.push(e.self);c.each(e.on[g],function(l,m){if(m===d||c.inArray(l,j)!==-1){return true}var k=m.apply(e.contexts[l],h);return f=(k===d||k)});return f},requestHandler:function(f){if(!e.self.ajax({},this,f)){return}},ext:function(h,g,f){while(!f){f="ext_"+Math.random();if(e.contexts[f]){f=d}}c.each(h,function(i,j){e.on[i][f]=j});e.contexts[f]=c.extend(g?g:{},{name:function(){return f},ext:function(i,k){var j=e.contexts[i];if(!j&&k){throw"Extension '"+this.name()+"' depends on disabled extension '"+i+"'."}return j}})}};this.ext=function(f,h,g){if(typeof f=="object"){e.ext(f,h)}else{if(h===d){return e.contexts[f]}else{if(!h){c.each(["init","load","prepare","before","start","success","complete","error"],function(i,j){e.on[j][f]=d});e.contexts[f]=d}else{if(typeof f=="string"&&e.contexts[f]!==d){throw"Cannot override already registered nette-ajax extension '"+f+"'."}else{e.ext(h,g,f)}}}}return this};this.init=function(g,f){if(e.initialized){throw"Cannot initialize nette-ajax twice."}if(typeof g=="function"){this.ext("init",null);this.ext("init",{load:g},f)}else{if(typeof g=="object"){this.ext("init",null);this.ext("init",g,f)}else{if(g!==d){throw"Argument of init() can be function or function-hash only."}}}e.initialized=true;e.fire("init");this.load();return this};this.load=function(){e.fire("load",e.requestHandler);return this};this.ajax=function(h,i,j){if(!h.nette&&i&&j){var f=c(i),l,k;var g=h.nette={e:j,ui:i,el:f,isForm:f.is("form"),isSubmit:f.is("input[type=submit]")||f.is("button[type=submit]"),isImage:f.is("input[type=image]"),form:null};if(g.isSubmit||g.isImage){g.form=g.el.closest("form")}else{if(g.isForm){g.form=g.el}}if(!h.url){h.url=g.form?g.form.attr("action"):i.href}if(!h.type){h.type=g.form?g.form.attr("method"):"get"}if(f.is("[data-ajax-off]")){h.off=f.data("ajaxOff");if(typeof h.off=="string"){h.off=[h.off]}}}e.fire({name:"prepare",off:h.off||{}},h);if(h.prepare){h.prepare(h)}k=h.beforeSend;h.beforeSend=function(o,n){if(k){var m=k(o,n);if(m!==d&&!m){return m}}return e.fire({name:"before",off:n.off||{}},o,n)};l=c.ajax(h);if(l&&(typeof l.statusText==="undefined"||l.statusText!=="canceled")){l.done(function(n,m,o){e.fire({name:"success",off:h.off||{}},n,m,o)}).fail(function(o,m,n){e.fire({name:"error",off:h.off||{}},o,m,n)}).always(function(n,m){e.fire({name:"complete",off:h.off||{}},n,m)});e.fire({name:"start",off:h.off||{}},l,h);if(h.start){h.start(l,h)}}return l}};c.nette=new (c.extend(a,c.nette?c.nette:{}));c.fn.netteAjax=function(g,f){return c.nette.ajax(f||{},this[0],g)};c.fn.netteAjaxOff=function(){return this.off(".nette")};c.nette.ext("validation",{before:function(l,i){if(!i.nette){return true}else{var h=i.nette}var j=h.e;var k=c.extend({keys:true,url:true,form:true},i.validate||(function(){if(!h.el.is("[data-ajax-validate]")){return}var e=h.el.data("ajaxValidate");if(e===false){return{keys:false,url:false,form:false}}else{if(typeof e=="object"){return e}}})()||{});var f=false;if(h.el.attr("data-ajax-pass")!==d){f=h.el.data("ajaxPass");f=typeof f=="bool"?f:true}if(k.keys){var g=j.button||j.ctrlKey||j.shiftKey||j.altKey||j.metaKey;if(h.form){if(g&&h.isSubmit){this.explicitNoAjax=true;return false}else{if(h.isForm&&this.explicitNoAjax){this.explicitNoAjax=false;return false}}}else{if(g){return false}}}if(k.form&&h.form&&!((h.isSubmit||h.isImage)&&h.el.attr("formnovalidate")!==d)){if(h.form.get(0).onsubmit&&h.form.get(0).onsubmit()===false){j.stopImmediatePropagation();j.preventDefault();return false}}if(k.url){if(/:|^#/.test(h.form?i.url:h.el.attr("href"))){return false}}if(!f){j.stopPropagation();j.preventDefault()}return true}},{explicitNoAjax:false});c.nette.ext("forms",{init:function(){var e;if(!b.Nette||!(e=this.ext("snippets"))){return}e.after(function(f){f.find("form").each(function(){b.Nette.initForm(this)})})},prepare:function(i){var h=i.nette;if(!h||!h.form){return}var l=h.e;var j=i.data||{};var k={};if(h.isSubmit){k[h.el.attr("name")]=h.el.val()||""}else{if(h.isImage){var m=h.el.offset();var g=h.el.attr("name");var f=[Math.max(0,l.pageX-m.left),Math.max(0,l.pageY-m.top)];if(g.indexOf("[",0)!==-1){k[g]=f}else{k[g+".x"]=f[0];k[g+".y"]=f[1]}}}if(typeof j!="string"){j=c.param(j)}k=c.param(k);i.data=h.form.serialize()+(k?"&"+k:"")+"&"+j}});c.nette.ext("snippets",{success:function(h){var g=[];if(h.snippets){for(var f in h.snippets){var e=this.getElement(f);c.each(this.beforeQueue,function(i,j){if(typeof j=="function"){j(e)}});this.updateSnippet(e,h.snippets[f]);c.each(this.afterQueue,function(i,j){if(typeof j=="function"){j(e)}})}}this.before(g)}},{beforeQueue:[],afterQueue:[],before:function(e){this.beforeQueue.push(e)},after:function(e){this.afterQueue.push(e)},updateSnippet:function(g,f,e){if(typeof g=="string"){g=this.getElement(g)}if(g.is("title")){document.title=f}else{this.applySnippet(g,f,e)}},getElement:function(e){return c("#"+this.escapeSelector(e))},applySnippet:function(g,f,e){if(!e&&g.is("[data-ajax-append]")){g.append(f)}else{g.html(f)}},escapeSelector:function(e){return e.replace(/[\!"#\$%&'\(\)\*\+,\.\/:;<=>\?@\[\\\]\^`\{\|\}~]/g,"\\$&")}});c.nette.ext("redirect",{success:function(e){if(e.redirect){b.location.href=e.redirect;return false}}});c.nette.ext("state",{success:function(e){if(e.state){this.state=e.state}}},{state:null});c.nette.ext("unique",{start:function(e){if(this.xhr){this.xhr.abort()}this.xhr=e},complete:function(){this.xhr=null}},{xhr:null});c.nette.ext("abort",{init:function(){c("body").keydown(c.proxy(function(f){if(this.xhr&&(f.keyCode==27&&!(f.ctrlKey||f.shiftKey||f.altKey||f.metaKey))){this.xhr.abort()}},this))},start:function(e){this.xhr=e},complete:function(){this.xhr=null}},{xhr:null});c.nette.ext("load",{success:function(){c.nette.load()}});c.nette.ext("init",{load:function(e){c(this.linkSelector).off("click.nette",e).on("click.nette",e);c(this.formSelector).off("submit.nette",e).on("submit.nette",e).off("click.nette",":image",e).on("click.nette",":image",e).off("click.nette",":submit",e).on("click.nette",":submit",e);c(this.buttonSelector).closest("form").off("click.nette",this.buttonSelector,e).on("click.nette",this.buttonSelector,e)}},{linkSelector:"a.ajax",formSelector:"form.ajax",buttonSelector:'input.ajax[type="submit"], button.ajax[type="submit"], input.ajax[type="image"]'})})(window,window.jQuery);
/*! - end */

function showErrors(errors, focus) {
    errors.forEach(function(error) {
        if (error.message) {
            $(error.element).parent().addClass('error');
            $(error.element).parent().attr("title", error.message);
        }
        if (focus && error.element.focus) {
            error.element.focus();
            focus = false;
        }
    });
}
function removeErrors(elem) {
    if ($(elem).is('form')) {
        $('.error', elem).removeClass('error');
        //$('.error', elem).remove();
    } else {
        $(elem).parent().removeClass('error');
    }
}

Nette.showFormErrors = function(form, errors) {
    removeErrors(form);
    showErrors(errors, true);
};
$(function() {
    var inp = $('form#frm-* :input');
    inp.keypress(function() {
        removeErrors(this);
    });
    inp.blur(function() {
        Nette.formErrors = [];
        Nette.validateControl(this);
        showErrors(Nette.formErrors);
    });
});
